module.exports = __webpack_public_path__ + "img/9791187147497.65fd8060.jpg";